type TicketItem = {
  name: string;
  quantity: number;
  price?: number;
  unitPrice?: number;
  totalAmount?: number;
};

const formatCurrency = (cents: number): string =>
  (Number.isFinite(cents)
    ? `R$ ${(cents / 100).toFixed(2).replace(".", ",")}`
    : "indisponível");

export const formatKitchenTicketItems = (items: TicketItem[]): string => {
  const lines = items.map((item) => {
    const unitPrice = Number.isFinite(item.unitPrice) ? item.unitPrice : item.price;
    const subtotal = Number.isFinite(item.totalAmount)
      ? item.totalAmount
      : item.quantity * (unitPrice ?? NaN);

    return {
      subtotal,
      text: `${item.quantity} - ${item.name} ${formatCurrency(subtotal ?? NaN)}`,
    };
  });

  const total = lines.reduce((sum, line) => sum + (line.subtotal ?? NaN), 0);
  return [
    "Itens:",
    ...lines.map((line) => line.text),
    "--------------------",
    `Total: ${formatCurrency(total)}`,
  ].join("\n");
};
